import styled from "styled-components";

export const Container = styled.div`
	position: absolute;
	top: 0;
	width: 100%;
	overflow: hidden;
	z-index: 0;
	display: none;
	height: 50vh;

	@media (min-width: 750px) {
		display: block;
	}
`;

export const BannerImage = styled.img`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: bottom center;
`;
